import { Controller } from '@hotwired/stimulus'

// Sub-step 2/9 fiscalité / FATCA conditional fields:
// - reveals the NIF field (and toggles its `required`) when the tax residence
//   country is set and is not France
// - reveals the orange "US person" notice when the FATCA answer is "yes"
export default class extends Controller {
  static targets = ['taxResidence', 'nifField', 'nifInput', 'usPerson', 'usPersonNotice']

  connect() {
    this.toggleNif()
    this.toggleUsPersonNotice()
  }

  toggleNif() {
    const country = this.taxResidenceTarget.value
    const requiresNif = country !== '' && country !== 'FR'

    this.nifFieldTarget.classList.toggle('d-none', !requiresNif)
    this.nifInputTarget.required = requiresNif
  }

  toggleUsPersonNotice() {
    this.usPersonNoticeTarget.classList.toggle('d-none', !this.#isUsPerson())
  }

  #isUsPerson() {
    const selected = this.usPersonTargets.find((radio) => radio.checked)

    return selected ? selected.value === 'true' : false
  }
}
